import {Trans} from '@common/i18n/trans';
import {Dialog} from '@common/ui/overlays/dialog/dialog';
import {DialogBody} from '@common/ui/overlays/dialog/dialog-body';
import {DialogHeader} from '@common/ui/overlays/dialog/dialog-header';
import {closeDialog, openDialog} from '@common/ui/overlays/store/dialog-store';
import {useGetAvatarList} from './titles/requests/use-avatar-list';
import AddProfileDialog from './addProfileDialog';

function AvatarListDialog() {
  const chosenAvatar = localStorage.getItem('chosenAvatar');

  const avatarList = useGetAvatarList();

  return (
    <Dialog size="fullscreen">
      <DialogHeader
        onDismiss={() => {
          closeDialog(AvatarListDialog);
        }}
      >
        <span className="text-base">
          <Trans message="Avatar List" />
        </span>
      </DialogHeader>
      <DialogBody className="w-full">
        <div className="max-w-full">
          <span className="text-base">
            <Trans message="Add a profile for your account" />
          </span>
          <div className="mt-[20px] space-y-[10px]">
            <div className="flex flex-wrap justify-center gap-[10px]">
              {avatarList?.data?.map(avatar => (
                <img
                  //@ts-expect-error
                  className={`h-[150px] w-[150px] rounded-full ${chosenAvatar === avatar.id ? 'border border-white' : ''}`}
                  src={avatar?.url}
                  alt=""
                  onClick={() => {
                    closeDialog(AvatarListDialog);
                    openDialog(AddProfileDialog);
                    localStorage.setItem('chosenAvatar', avatar.id.toString());
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      </DialogBody>
    </Dialog>
  );
}

export default AvatarListDialog;
